<template>
  <div
    :class="slideClass"
    @click="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SwiperSlide',
  data() {
    return {
      slideClass: 'swiper-slide'
    }
  },
  mounted() {
    if (this.$parent && this.$parent.options && this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>
